<div
  class="w-full h-full pointer-events-auto cursor-not-allowed bg-black/40 flex justify-center overflow-hidden select-none"
  [@EnterLeave]="'flyIn'"
  *ngIf="active"
>
  <div class="w-full h-2 overflow-hidden bg-white">
    <div class="h-full w-[50%] animate-progress bg-cbde-green"></div>
  </div>
</div>
